import bagReducer  from './Bags/BagReducer.js';
import finalizeReducer  from './Finalize/FinalizeReducer.js';
import SelectedPassengerReducer  from './SelectedPassenger/SelectedPassengerReducer.js';
import loginReducer  from './Login/LoginReducer.js';
import paymentReducer  from './Payment/PaymentReducer.js';
import searchReducer  from './Search/SearchReducer.js';
import seatReducer  from './Seats/SeatReducer.js';
import serviceReducer from  './Service/ServiceReducer.js';
import sidebarReducer from './Sidebar/SidebarReducer.js';
import spiceclubeducer from './SpiceClub/SpiceClubReducer.js';
import sideMenuReducer from './Sidemenu/SideMenuReducer.js';
import flightSearchReducer from './FlightSearch/FlightSearchReducer.js';
import docverifyReducer from './DocumentVerification/DocVerifyReducer.js';
import {combineReducers} from 'redux';
import { persistReducer } from 'redux-persist'
import printModeReducer from './PrintModeModal/PrintModeModalReducer.js'; // added
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

 
const persistConfig = {
  key: 'root',
  storage,
  whitelist:['login','docverifyReducer','search','selectedpassenger']
}

const flightSearchPersistConfig = {
  key: 'flightSearch',
  storage,
  whitelist: ['flightManifestBoarding', 'flightTripBoarding', 'selectedFlight', 'assistQueue']
  // ['flightManifestBoarding', 'flightTripBoarding', 'selectedFlight', 'assistQueue']
}

const printModePersistConfig = {
  key: 'printMode',
  storage,
  whitelist: ['PrintModeModalStatus', 'selectedMode']
};

// it will persistconfig what is white list
// const searchPersistConfig = {
//   key: 'search',
//   storage,
//   whitelist: ['SearchedRecordData', 'SearchedFlightDetails', 'isBagAdded', 'isJumpSeatSelected', 'isInternationalDocumentVerified', 'lrtBagTypeForPassenger']
//   // ['flightManifestBoarding', 'flightTripBoarding', 'selectedFlight', 'assistQueue']
// }

const rootReducer = combineReducers({
    // bag:bagReducer,
    finalize:finalizeReducer,
    selectedpassenger:SelectedPassengerReducer,
    login:loginReducer,
    payment:paymentReducer,
    search:searchReducer, //persistReducer(searchPersistConfig, searchReducer), //searchReducer,
    seat:seatReducer,
    service:serviceReducer,
    sidebar:sidebarReducer,
    spiceclub:spiceclubeducer,
    sidemenu: sideMenuReducer,
    docVerify: docverifyReducer,
    // flightSearch: flightSearchReducer
    flightSearch: persistReducer(flightSearchPersistConfig, flightSearchReducer),
    // printMode: printModeReducer
    printMode: persistReducer(printModePersistConfig, printModeReducer)
})

export default persistReducer(persistConfig, rootReducer);